import { useCallback, useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { addHandholdingBannerParamsToLink } from '../utils/urls';
import { trackUserInteraction } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NextActionModalFooter = ({
  text,
  button,
  trackingProperties = {},
  handholdingBanner
}) => {
  var _button$target;
  const handleButtonClick = useCallback((...args) => {
    var _button$onClick;
    (_button$onClick = button.onClick) === null || _button$onClick === void 0 || _button$onClick.call(button, ...args);
    trackUserInteraction('next action modal', 'click footer button', trackingProperties);
  }, [trackingProperties, button]);
  const hrefWithHandholdingBannerParams = useMemo(() => addHandholdingBannerParamsToLink(button.href, handholdingBanner), [button.href, handholdingBanner]);
  return /*#__PURE__*/_jsxs(DialogFooter, {
    align: "between",
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-container-default",
    children: [text && /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      color: "text-core-subtle",
      children: text
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "next-action-modal-footer-button",
      use: "tertiary",
      onClick: handleButtonClick,
      href: hrefWithHandholdingBannerParams,
      target: (_button$target = button.target) !== null && _button$target !== void 0 ? _button$target : '_top',
      children: button.text
    })]
  });
};